<style lang="scss" scoped>
  .news-lists{
    padding:0 5%;
    li{
      display: flex;
      align-items: center;
      padding:30px 0;
      border-bottom: 1px solid #eee;
      cursor: pointer;
      .title{
        font-weight: bold;
        font-size: 16px;
        margin-bottom: 10px;
        &:hover{
          color: #014492;
        }
      }
      .time{
        font-size: 28px;
        text-align: right;
        border-right: 1px solid #eee;
        padding:0 20px;
        margin-right: 20px;
        small{
          font-size: 16px;
          display: block;
        }
      }
      .info{
        flex:1
      }
    }
  }
  @media screen and (max-width: 640px){
    .container{
      width: 100% !important;
    }
    .news-lists li .title {
      font-size: 14px!important;
    }
    .news-lists li .time {
      font-size: 18px!important;
    }
  }
  @media screen and (max-width: 641px){
    .wrap-summary .breads{
      display: none!important;
    }
  }
</style>
<template>
  <div class="wrap wrap-summary">
    <div class="banner">
      <img src="@/assets/img/news.png" class="img-fluid">
      <qk-top-tabs :menuLists="newsTabs" @getLists="changeTab"></qk-top-tabs>
    </div>
    <div class="breads container" style="overflow:auto;line-height: 48px;padding-left: 10px;margin-bottom:  20px;margin-top: 20px;">
      <bread></bread>
    </div>
    <div class="container">
      <ul class="news-lists">
        <li v-for="item in newsLists" :key="item.id" @click="$router.push(`/news/details/${item.id}`)">
          <div class="time">{{item.date}}<small>{{item.year}}-{{item.month}}</small></div>
          <div class="info">
            <div class="title">{{item.name}}</div>
            <p class="text-ellipsis2" v-html="item.summary"></p>
          </div>
        </li>
      </ul>
      <div class="no-data" v-show="newsLists.length === 0">暂无数据</div>
      <div class="page" v-show="total > 0">
        <el-pagination
          background
          layout="prev, pager, next"
          :total="total"
          :page-size="5"
          @current-change="changePage">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { newsColumns, newsInformation } from '@/services/api.index'
import bread from "@/components/bread"
export default {
  components:{
    bread
  },
  data () {
    return {
      newsTabs: [],
      newsLists: [],
      total: 0,
      page: 0,
      currentId: this.$route.query.id
    }
  },
  created () {
    this.getNewsTabs()
  },
  methods: {
    // 获取新闻栏目
    getNewsTabs () {
      newsColumns().then(res => {
        this.newsTabs = res.data
        if (this.currentId) {
          this.getNews(this.currentId)
        } else {
          this.getNews(res.data[0].id)
        }
      })
    },
    changeTab (id) {
      this.page = 0
      this.getNews(id)
    },
    getNews (id) {
      newsInformation(id, this.page, 5).then(res => {
        res.data.map(item => {
          item.year = this.baseMethods.formatDate(item.createTime)[0]
          item.month = this.baseMethods.formatDate(item.createTime)[1]
          item.date = this.baseMethods.formatDate(item.createTime)[2]
        })
        this.newsLists = res.data
        this.currentId = id
        this.total = this.baseMethods.getTotal(res)
      })
    },
    // 翻页
    changePage (value) {
      this.page = value - 1
      this.getNews(this.currentId)
    }
  },
  watch: {
    $route (to) {
      this.page = 0
      this.getNews(to.query.id)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/news/index.vue